export default "__VITE_ASSET__DHqh8ypA__";